import React, { useMemo, useReducer } from 'react';
import IsolatedLayout from '../../../../views/AuthView/IsolatedLayout';
import { Texter } from 'kinedu-react-components';
import TexterBasic from '../../../../views/AuthView/styles/themes/TexterBasic';
import { parse } from 'query-string';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import {
  MainButton,
  Title,
  Subtitle,
  InputGroup,
  ErrorMessage,
} from './styles';
import i18n from 'i18n';
import { useParams } from 'react-router-dom';

const reducer = (state, action) => {
  switch (action.type) {
  case 'SET_INPUT_VALUE':
    return { ...state, [action.name]: action.value };
  default:
    throw new Error();
  }
};

const initialState = {
  password: '',
  confirmPassword: '',
};

const ResetPassword = () => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const { reset_password_token: token } = parse(window.location.search);
  const [data, dispatch] = useReducer(reducer, initialState);
  const { password, confirmPassword } = data;
  const { resetPassword, errors, setErrors } = useAuth();

  const handleResetPassword = () => {
    const isPassEmpty = data.password === '' ? 'Password is required' : '';
    const isConfirmPassEmpty = data.confirmPassword === '' ? 'Confirm password is required' : '';
    const bothFieldsEmpty = isPassEmpty || isConfirmPassEmpty;
    const fieldsDontMatch = data.password !== data.confirmPassword
      && !isPassEmpty && !isConfirmPassEmpty
      ? 'Passwords do not match'
      : '';
    setErrors({
      ...errors,
      passError: isPassEmpty,
      confirmPassError: isConfirmPassEmpty,
      generalError: fieldsDontMatch,
    });
    if (bothFieldsEmpty || fieldsDontMatch) return;
    resetPassword(token, password, confirmPassword, 'reset-password');
  };

  const handleOnChange = (name, value) => {
    dispatch({ type: 'SET_INPUT_VALUE', name, value });
  };

  useMemo(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return (
    <IsolatedLayout>
      <Title>{t('auth:RESET_PASS_VIEW.TITLE')}</Title>
      <Subtitle>{t('auth:RESET_PASS_VIEW.SUBTITLE')}</Subtitle>
      <InputGroup>
        <Texter
          theme={TexterBasic}
          name="password"
          label={t('auth:RESET_PASS_VIEW.NEW_PASSWORD')}
          type="password"
          onChange={(value) => handleOnChange('password', value)}
          value={data.password}
        />
        <ErrorMessage>{t(errors.passError)}</ErrorMessage>
        <Texter
          theme={TexterBasic}
          name="confirmpassword"
          label={t('auth:RESET_PASS_VIEW.CONFIRM_PASSWORD')}
          type="password"
          onChange={(value) => handleOnChange('confirmPassword', value)}
          value={data.confirmPassword}
        />
        <ErrorMessage>
          {t(errors.generalError || errors.confirmPassError)}
        </ErrorMessage>
        <MainButton fill onClick={handleResetPassword}>
          {t('auth:CHANGE_PASS')}
        </MainButton>
      </InputGroup>
    </IsolatedLayout>
  );
};

export default ResetPassword;
